import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://be5e20432e024753e01a31647456e18f@o4512208148692992.ingest.de.sentry.io/4512208158589008',
  enabled: import.meta.env.PROD,
  dataCollection: {
    userInfo: false,
  },
})
